export default "../css/4e7c36910135c00904c92ce44fd518f5.ttf";